import { PlusOutlined } from "@ant-design/icons";
import { Avatar, Typography } from "antd";
import { ButtonProps } from "antd/lib";
import styled from "styled-components";

export const StyledProductCardWithCounter = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    gap: 8px;
    justify-content: space-between;
    border-bottom: 1px solid #313131;
`;

export const StyledProductCardWithCounterContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const StyledProductCardWithCounterTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
`;

export const StyledProductCardWithCounterBottom = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
`;

export const StyledProductTitle = styled(Typography)`
    width: 70%;
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    text-align: left;
    && {
        color: ${(props) => props.theme.primaryTypographyColor} !important;
    }
`;

export const StyledProductInfoText = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: #5f5f5f;
`;

export const StyledCounter = styled(StyledProductInfoText)<{
    isPositive: boolean;
}>`
    ${({ isPositive, theme }) =>
        isPositive && `color: ${theme.primaryTypographyColor}`};
`;

export const StyledProductAdditionalInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

interface IStyledAddButton extends ButtonProps {
    $isDisabled: boolean;
}

export const StyledAddButton = styled(Avatar)<IStyledAddButton>`
    cursor: pointer;
    background-color: ${(props) =>
        props.$isDisabled ? props.theme.collapseHeaderBackground : "#49aa19"};
    cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
    min-width: 40px;
    min-height: 40px;
    max-width: 40px;
    max-height: 40px;
    touch-action: manipulation;
`;

export const StyledPlusOutlined = styled(PlusOutlined)<{
    $isCountDisabled?: boolean;
}>`
    color: ${({ theme, $isCountDisabled }) =>
        $isCountDisabled ? "#313131" : theme.colors.white};
`;
